/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import moment from "moment";

/** CSS Files */
import "./Calendar.scss";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";

/** Common Components */
import CenterModel from "../centerModel/CenterModel";

/** RTK Query */
import { useLazyGetAllTimeSheetRecordsQuery } from "../../../app/services/timeSheetLogAPI";
import TimeLogPopup from "../../timeLogPopup/NewTimeLogPopup";

const localizer = momentLocalizer(moment);
const DnDCalendar = withDragAndDrop(Calendar);

const CalendarComponent = () => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [creatingEvent, setCreatingEvent] = useState(false);
  const [slotInfo, setSlotInfo] = useState(null);
  const [weekDate, setWeekDate] = useState(new Date().toISOString());

  const [getAllTimeSheetRecords, {
    isFetching: isAllRecordsFetching,
    isSuccess: isAllRecordsSuccess,
    data: timeSheetRecordsData
  }] = useLazyGetAllTimeSheetRecordsQuery();

  const handleSelectSlot = (slotInfo) => {
    setSlotInfo(slotInfo);
    setCreatingEvent(true);
    setShowPopup(true);
  };

  const handleSelectEvent = (event) => {
    setSelectedEvent(event);
    setCreatingEvent(false);
    setShowPopup(true);
  };

  const handleEventDrop = ({ event, start, end }) => {
    const updatedEvents = events.map((existingEvent) =>
      existingEvent === event
        ? { ...existingEvent, start, end }
        : existingEvent
    );
    setEvents(updatedEvents);
  };

  const handleEventResize = ({ event, start, end }) => {
    const updatedEvents = events.map((existingEvent) =>
      existingEvent === event
        ? { ...existingEvent, start, end }
        : existingEvent
    );
    setEvents(updatedEvents);
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedEvent(null);
    setSlotInfo(null);
  };

  const handleSuccess = () => {
    setShowPopup(false);
    setSelectedEvent(null);
    getAllTimeSheetRecords(weekDate);
  }

  const handleCreateOrUpdateEvent = (eventDetails) => {
    if (creatingEvent) {
      setEvents([
        ...events,
        {
          start: eventDetails.start,
          end: eventDetails.end,
          title: eventDetails.title,
        },
      ]);
    } else {
      const updatedEvents = events.map((existingEvent) =>
        existingEvent === selectedEvent
          ? { ...existingEvent, ...eventDetails }
          : existingEvent
      );
      setEvents(updatedEvents);
    }
    closePopup();
  };

  const handleNavigate = (date, view, action) => {
    setWeekDate(date.toISOString())
  };

  useEffect(() => {
    if (weekDate) {
      getAllTimeSheetRecords(weekDate);
    }
  }, [weekDate]);

  useEffect(() => {
    if (!isAllRecordsFetching && isAllRecordsSuccess && timeSheetRecordsData) {
      const eventList = timeSheetRecordsData.map((item) => ({
        ...item,
        start: new Date(`${item.workAt.split('T')[0]}T${item.startTime}`),
        end: new Date(`${item.workAt.split('T')[0]}T${item.endTime}`),
        title: item.workDescription,
      }));
      setEvents(eventList)
    }
  }, [isAllRecordsFetching, isAllRecordsSuccess, timeSheetRecordsData]);

  return (
    <div className="calendar-container">
      <DnDCalendar
        scrollToTime={new Date()}
        defaultView="week"
        views={['week', 'day']}
        step={15} // 30-minute intervals
        timeslots={1} // Number of slots per interval
        localizer={localizer}
        events={events}
        selectable
        onSelectSlot={handleSelectSlot}
        onSelectEvent={handleSelectEvent}
        onEventDrop={handleEventDrop}
        onEventResize={handleEventResize}
        resizable
        style={{ height: "100vh" }}
        onNavigate={handleNavigate}
      />
      {showPopup && (
        <CenterModel
          showModal={showPopup}
          className="header-task-center-model"
          handleToggleModal={closePopup}
          modalTitle={creatingEvent ? "Create Event" : "Edit Event"}
          modelSizeClass="w-55"
        >
          {/* <EventForm
            event={creatingEvent ? null : selectedEvent}
            onSave={handleCreateOrUpdateEvent}
            onClose={closePopup}
            slotInfo={slotInfo}
          /> */}
          <TimeLogPopup
            isOpen={showPopup}
            event={creatingEvent ? null : selectedEvent}
            onSave={handleCreateOrUpdateEvent}
            onClose={closePopup}
            onSuccess={handleSuccess}
            slotInfo={slotInfo}
          />
        </CenterModel>
      )}
    </div>
  );
};

export default CalendarComponent;
